"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnauthorizedReasonError = exports.TokenRetrievalError = exports.NetworkAbortError = exports.ERROR_MESSAGES = exports.BaseError = void 0;
/* eslint-disable max-classes-per-file */
class BaseError extends Error {
  headers;
  constructor(name, message, headers) {
    super(message);
    this.name = name;
    this.headers = headers;
  }
}
exports.BaseError = BaseError;
class TokenRetrievalError extends BaseError {
  constructor(message, headers) {
    super("TokenRetrievalError", message, headers);
  }
}
exports.TokenRetrievalError = TokenRetrievalError;
class NetworkAbortError extends BaseError {
  constructor(message, headers) {
    super("NetworkAbortError", message, headers);
  }
}
exports.NetworkAbortError = NetworkAbortError;
class UnauthorizedReasonError extends BaseError {
  constructor(message, headers) {
    super("UnauthorizedReasonError", message, headers);
  }
}
exports.UnauthorizedReasonError = UnauthorizedReasonError;
const ERROR_MESSAGES = exports.ERROR_MESSAGES = {
  TOKEN_RETRIEVAL: "API error when retrieving user",
  NETWORK_ABORT: "Network request aborted",
  UNAUTHORIZED: "User is unauthorized",
  VALIDATION: "Validation Error",
  HTTP_ERROR: "HTTP request failed",
  API_ERROR: "API error when retrieving user.",
  TOKEN_REFRESH_FAILED: "Refresh tokens failed"
};